import KbHeader from './KBHeader';

export default KbHeader;
